var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("Testing Moolah")]),_c('ErrorDisplay'),_c('div',{attrs:{"id":"card-element"}}),_c('button',{on:{"click":_vm.test}},[_vm._v("Pay")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }